<template>
  <div class="list-page">
      <transition name="fade" mode="out-in">
          <div key="list" class="bg-wrap-color">
              <el-form
                  :inline="true"
                  :model="formInline"
                  ref="formInline"
                  class="demo-form-inline bg-color"
                  size="mini"
                  @submit.native.prevent="onSubmit"
              >
                  <el-form-item  prop="task_id">
                    <custom-input label="任务ID">
                         <el-input
                            v-model="formInline.task_id"
                            placeholder="任务ID"
                            style="width: 100px"
                            clearable
                            @keyup.enter.native="onSubmit"
                        ></el-input>
                    </custom-input>
                     
                  </el-form-item>
                  <el-form-item  prop="account_id">
                    <custom-input label="目标账户">
                        <ESelect
                            v-model="formInline.account_id"
                            placeholder="账户名称关键字或账户ID搜索"
                            style="width: 260px"
                            class="tagswidth select-option-long-text-wrap remote-select-tags-width"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            reserve-keyword
                            remote
                            :loading="accountOptionsLoading"
                            :remote-method="remoteAccountSearchList"
                            @visible-change="(val)=>visibleVirtual(val,'account')"
                        >
                            <VirtualList
                                ref="virtualList"
                                data-key="id"
                                style="max-height: 245px; overflow-y: auto;"
                                :data-sources="account"
                                :data-component="itemComponent"
                                :keeps="20"
                                :estimate-size="50"
                            />
                            <!--<el-option-->
                                <!--v-for="item in account"-->
                                <!--:key="item.id"-->
                                <!--:label="item.name+item.id"-->
                                <!--:value="item.id">-->
                                <!--<span>{{ item.name }}</span>-->
                            <!--</el-option>-->
                        </ESelect>
                       </custom-input>
                  </el-form-item>
                  <el-form-item  prop="app_id">
                    <custom-input label="投放产品">
                        <ESelect
                            v-model="formInline.app_id"
                            placeholder="产品名称关键字或产品ID搜索"
                            style="width: 260px"
                            class="tagswidth select-option-long-text-wrap remote-select-tags-width"
                            multiple
                            collapse-tags
                            clearable
                            filterable
                            reserve-keyword
                            disabled
                            remote
                            :loading="appOptionsLoading"
                            :remote-method="remoteAppSearchList"
                            @visible-change="(val)=>visibleVirtual(val,'app')"
                        >
                            <el-option
                                v-for="item in app"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                <span>{{ item.name }}</span>
                            </el-option>
                        </ESelect>
                      </custom-input>
                  </el-form-item>
                  <el-form-item  prop="creator">
                        <custom-input label="创建人">
                            <ESelect
                                v-model="formInline.creator"
                                placeholder="支持名称关键字搜索"
                                style="width: 160px"
                                multiple
                                collapse-tags
                                clearable
                                filterable
                                @focus="()=>handleFouce('creator')"
                            >
                                <el-option
                                    v-for="item in creator"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </ESelect>
                       </custom-input>
                  </el-form-item>
                  <el-form-item  prop="department" v-show="isHasCreateDepartment">
                     <custom-input label="创建部门">
                      <ESelect
                          v-model="formInline.department"
                          placeholder="支持名称关键字搜索"
                          style="width: 180px"
                          clearable
                          filterable
                          multiple
                          collapse-tags
                          @focus="()=>handleFouce('department')"
                      >
                          <el-option
                              v-for="item in department"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                          </el-option>
                      </ESelect>
                     </custom-input>
                  </el-form-item>
                  <el-form-item  prop="range_time">
                    <custom-input label="创建时间">
                      <el-date-picker
                          v-model="range_time"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="basePickerOptions"
                          value-format="yyyy-MM-dd"
                          :clearable="false"
                          style="width: 240px"
                      >
                      </el-date-picker>
                    </custom-input>
                  </el-form-item>
                  <el-form-item  prop="status">
                    <custom-input label="任务状态">
                      <el-select
                          v-model="formInline.status"
                          placeholder="任务状态"
                          style="width: 180px"
                          multiple
                          collapse-tags
                          clearable
                      >
                          <el-option
                              label="创建中"
                              value="1"
                          ></el-option>
                          <el-option
                              label="创建成功"
                              value="2"
                          ></el-option>
                          <el-option
                              label="创建失败"
                              value="3"
                          ></el-option>
                          <el-option
                              label="部分创建失败"
                              value="4"
                          ></el-option>
                      </el-select>
                    </custom-input>
                  </el-form-item>

                  <el-divider class="mt0 mb10" />
                  <el-form-item class="">
                      <el-button type="primary" @click="onSubmit" :loading="loading" v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '筛选(查询)' }">查询</el-button>
                      <el-button @click="resetForm('formInline',true)" v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '筛选(清空筛选)' }">清空筛选</el-button>
                  </el-form-item>
              </el-form>
              <div class="bg-color p10">
                  <div class="pb10">
                      <el-button
                          v-if="isHasBatchCreate"
                          type="primary"
                          @click="toConfigPage"
                          size="mini"
                          v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '批量创建' }"
                      >批量创建</el-button>
                  </div>
                  <jt-table
                      :data="tableData"
                      style="width: 100%"
                      stripe
                      :header-cell-style="{background:'#e8eaec',color:'#333'}"
                      size="mini"
                      class="create_list"
                      :row-class-name="tableRowClassName"
                      v-loading="loading"
                      tooltip-effect="dark"
                  >
                      <el-table-column label="任务ID" width="80" prop="id">
                          <template slot-scope="scope">
                              <span v-if="scope.$index != 0">{{ scope.row.id }}</span>
                              <span v-else class="text-bold">汇总</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="目标账户" min-width="240" show-overflow-tooltip>
                          <template slot-scope="scope">
                              <div v-if="scope.$index != 0">
                                  <p class="ellipsis">{{scope.row.account_name}}({{scope.row.account_id}})</p>
                              </div>
                              <span v-else>{{scope.row.account_num_distinct}} / {{scope.row.account_num}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="投放产品" min-width="200">
                          <template slot-scope="scope">
                              <div v-if="scope.$index != 0">
                                  <div v-for="(item, index) in scope.row.app||[]" :key="index">
                                      <p>{{item.app_name||'--'}}({{item.app_id||'--'}})</p>
                                      <p>{{item.package_name}}</p>
                                  </div>
                              </div>
                              <span v-else>{{scope.row.app_num_distinct}} / {{scope.row.app_num}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column
                          label="创建计划规格(成功数量/总量)"
                          min-width="260"
                          show-overflow-tooltip
                      >
                          <template slot-scope="scope">
                              <div>
                                  <p class="ellipsis">
                                      计划(<span class="text-color-success">{{ scope.row.plan_num }}</span>/<span>{{ scope.row.plan_total }}</span>)；
                                      广告组(<span class="text-color-success">{{ scope.row.adgroup_num }}</span>/<span>{{ scope.row.adgroup_total }}</span>)；
                                      广告创意(<span class="text-color-success">{{ scope.row.ad_num }}</span>/<span>{{ scope.row.ad_total }}</span>)；</p>
                              </div>
                          </template>
                      </el-table-column>
                      <el-table-column label="任务状态" min-width="100">
                          <template slot-scope="scope">
                              <div v-if="scope.$index != 0">
                                  <!-- 1-创建中，2-成功，3-失败，4-部分失败  -->
                                  <p v-if="scope.row.status == 1" style="color: #409eff;">{{ scope.row.status_text}}<i class="el-icon-loading"></i></p>
                                  <p v-else-if="scope.row.status == 2" class="text-color-success">{{ scope.row.status_text}}</p>
                                  <div v-else class="text-color-error text-nowrap">
                                      <el-tooltip class="item" effect="dark"  placement="top" v-if="scope.row.err_msg">
                                        <div slot="content">
                                            <p class="mb6">您可点击任务详情查看具体失败计划，失败原因如下：</p>
                                            <div v-html="scope.row.err_msg.replace(/\\n/g, '<br/>')"></div>
                                        </div>
                                        <span class="pointer">{{ scope.row.status_text}}<i class="el-icon-warning-outline"></i></span>
                                    </el-tooltip>
                                      <span v-else>{{ scope.row.status_text}}</span>
                                  </div>
                                  <!--<p v-else-if="scope.row.status == 3" class="text-color-error">{{ scope.row.status_text}}</p>-->
                                  <!--<p v-else-if="scope.row.status == 4" class="text-color-error">{{ scope.row.status_text}}</p>-->
                                  <!--<span v-else>-</span>-->
                              </div>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="创建人" width="90" prop="name">
                          <template slot-scope="scope">
                              <span v-if="scope.$index != 0">{{ scope.row.name }}</span>
                              <span v-else>{{scope.row.creator_num_distinct}} / {{scope.row.creator_num}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="创建时间" width="90">
                          <template slot-scope="scope">
                              <span v-if="scope.$index != 0">{{ scope.row.ctime||'-' }}</span>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                      <el-table-column label="操作" align="center" width="180" fixed="right">
                          <template slot-scope="scope">
                              <template v-if="scope.$index != 0">
                                  <el-button  size="mini" type="text" @click="handleClick(scope.$index, scope.row)" v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '列表(任务详情)' }">任务详情</el-button>
                                  <el-button  size="mini" type="text" @click="toCopyConfigPage(scope.$index, scope.row)" v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '列表(复制)' }">复制</el-button>
                                  <el-button v-if="isHasRetryAuth" :disabled="!scope.row.status||scope.row.status=='1'||scope.row.status=='2'" :loading="scope.row.retryLoading" size="mini" type="text" @click="retryTask(scope.row)" v-matomo="{behaviorCategory: '小米(批量搭建)',  name: '列表(重试)' }">重试</el-button>
                              </template>
                              <span v-else>-</span>
                          </template>
                      </el-table-column>
                  </jt-table>
                  <div class="tar pt20 pr20">
                      <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="currentPage"
                          :page-sizes="[ 30, 50, 100]"
                          :page-size="pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                      >
                      </el-pagination>
                  </div>
              </div>

          </div>

      </transition>


  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import InfoPage from "./infoPage.vue";
    import API from '@/api/marketManage/miBatch.js';
    import dayjs from "dayjs";
    import VirtualList from 'vue-virtual-scroll-list';
    import OptionsItem from '../components/virtualListItem';

    export default {
        props:{
            pageFuncNames:Array,
            pageDimensionNames:Array,
            pageName: String
        },
        components: {
            InfoPage,
            VirtualList,
        },
        data() {
            return {
                itemComponent: OptionsItem,
                refreshTimer: null,
                loading: true,
                currentPage: 1,
                pageSize: 30,
                total: 10,
                tableData:[],
                range_time:[],      //创建时间
                account: [],            //select搜索
                app:[],            //select搜索
                creator: [],            //select搜索
                department: [],            //select搜索
                formInline: {
                    task_id: "",        //任务ID
                    account_id: "",     //账户ID
                    app_id:"",  //产品
                    creator: "",        //创始人
                    department: "",     //创始部门
                    status:""           //任务状态
                },
                queryParams:{},
                basePickerOptions: {
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [
                        {
                            text: '最近7天',
                            onClick(picker) {
                                const date = new Date();
                                let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
                                let endDate = new Date(date.getTime());
                                picker.$emit('pick', [startDate,endDate]);
                            }
                        },
                        {
                            text: '上周',
                            onClick(picker) {
                                // 上周：自然周，周一到周日
                                let date = new Date(new Date().getTime()-1000*60*60*24*7);
                                let weekDay = date.getDay();
                                let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                                let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate = year+'-'+month+'-1';
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上月',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth();
                                let startDate = new Date(year+'-'+month+'-01');
                                let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '本季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;
                                let day = date.getDate();
                                let startDate='';
                                if([1,2,3].includes(month)){
                                    startDate = year+'-01-01';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-04-01';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-07-01';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-10-01';
                                }
                                let endDate = year+'-'+month+'-'+day;
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '上季度',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let month = date.getMonth()+1;

                                let startDate='';
                                let endDate = '';
                                if([1,2,3].includes(month)){
                                    startDate = (year-1)+'-10-01';
                                    endDate = (year-1)+'-12-31';
                                }else if([4,5,6].includes(month)){
                                    startDate = year+'-01-01';
                                    endDate = year+'-03-31';
                                }else if([7,8,9].includes(month)){
                                    startDate = year+'-04-01';
                                    endDate = year+'-06-30';
                                }else if([10,11,12].includes(month)){
                                    startDate = year+'-07-01';
                                    endDate = year+'-09-30';
                                }
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '今年',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear();
                                let startDate= year+'-01-01';
                                let endDate = year+'-12-31';
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        },
                        {
                            text: '去年',
                            onClick(picker) {
                                let date = new Date();
                                let year = date.getFullYear()-1;
                                let startDate= year+'-01-01';
                                let endDate = year+'-12-31';
                                picker.$emit('pick', [startDate, endDate]);
                            }
                        }
                    ]
                },
                confirmTip:null,
                accountOptionsLoading:false,
                appOptionsLoading:false,
                departmentOptionsLoading:false,
                creatorOptionsLoading:false,
                allappOptions:[],
                allaccountOptions:[],
                retryUserList:[],
            }
        },
        computed:{
            ...mapGetters(['user_id']),
            isHasCreateDepartment(){
                /* 小米渠道：对需求时没说有权限控制 */
                return this.pageDimensionNames.includes('mi_create_department')||true;
            },
            isHasBatchCreate(){
                return this.pageFuncNames.includes('mi_batch_create');
            },
            isHasRetryAuth(){
                // return this.retryUserList.includes(this.user_id);
                return this.pageFuncNames.includes('mi_batch_retry');
            },
        },
        mounted() {
            let $routeParams = this.$route.params;
            let $routeQuery = this.$route.query;
            let pageType = $routeParams.pageType||$routeQuery.pageType||'';
            if(pageType=='mi_batch_task_list'&&($routeParams.search||$routeQuery.search)){
                this.jumpToPage();
            }else{
                this.renovate()
            }
            // this.getRetryUserList();
        },
        methods: {
            async getRetryUserList(){
                const { data } = await API.getRetryUserList();
                this.retryUserList = data||[];
            },
            renovate() {
                this.resetForm('formInline',false);
                this.getCreatorSearchList();
                if(this.isHasCreateDepartment){
                    this.getDepartmentSearchList();
                }
                let startDate = dayjs().subtract(6,'day').format("YYYY-MM-DD");
                let endDate = dayjs().format("YYYY-MM-DD");
                this.range_time = [startDate, endDate];
                this.inin()
            },
            onSubmit() {
                this.inin()
            },
            inin() {
                let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, range_time:this.range_time.join('/')}
                obj.department = this.isHasCreateDepartment? obj.department:'';
                this.loading = true
                this.polling(obj)
            },
            polling(params) {
                clearInterval(this.refreshTimer)
                this.refreshTimer = null
                this.queryParams = {...params};
                API.getTotalData(params).then(totalList=>{
                    let tlist = totalList.data||{};
                    API.getDataList(params).then(res=>{
                        let result = res.data||[];
                        let tableList = [tlist, ...result.list]
                        this.loading = false

                        let createarr = []
                        result.list.forEach(element => {
                            if(element.status == 1) {
                                createarr.push(element.id)
                            }
                        });
                        clearInterval(this.refreshTimer)
                        this.refreshTimer = null

                        this.tableData = tableList.map(item=>{
                            item.retryLoading = false;
                            return item;
                        })
                        this.currentPage = result.pageNum
                        this.pageSize = result.pageSize
                        this.total = result.totalCnt
                        // if(createarr.length != 0) {
                        //     let obj = {...this.formInline, pn: this.currentPage, rn: this.pageSize, range_time:this.range_time.join('/')}
                        //     obj.department = this.isHasCreateDepartment? obj.department:'';
                        //     if (this.pageName === 'listPage') {
                        //         console.log(this.pageName, 'listPage');
                        //         this.monitor = setTimeout(()=>{
                        //             this.polling(obj);
                        //         }, 5000)
                        //     }else {
                        //         clearTimeout(this.monitor)
                        //         this.monitor = null
                        //     }
                        // }
                        // this.startRefresh();
                    },err=>{
                        this.loading = false;
                        if (err.code == '403') {
                            if(this.confirmTip) return;
                            this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                                this.confirmTip = null;
                            }).catch(() => {
                                this.confirmTip = null;
                            });
                            return
                        }
                        this.$message.error(err.info)
                    })
                },err=>{
                    this.loading = false;
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info)
                })
            },
            startRefresh(){
                if(this.refreshTimer) return;

                this.refreshTimer = setInterval(()=>{
                    if(this.tableData.some(item=>item.status=='1')){
                        let obj = {...this.queryParams}
                        API.getTotalData(obj).then(totalList=>{
                            let tlist = totalList.data||{};
                            API.getDataList(obj).then(res=>{
                                let result = res.data||[];
                                let tableList = [tlist, ...result.list]
                                this.tableData = tableList.map(item=>{
                                    item.retryLoading = false;
                                    return item;
                                })
                            })
                        })
                    }
                },5*1000)
            },
            stopRefresh() {
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            },
            handleFouce(type) {
                if(type=='department'){
                    this.getDepartmentSearchList();
                }else if(type=='creator'){
                    this.getCreatorSearchList();
                }
            },
            resetForm(formName,isSearch) {
                this.$refs[formName].resetFields()
                this.formInline.task_id = ''
                this.formInline.account_id = ''
                this.formInline.app_id = ''
                this.formInline.creator = ''
                this.formInline.department = ''
                this.formInline.status = ''
                if(isSearch){
                    this.$nextTick(()=>{
                        this.inin()
                    })
                }
            },
            // 任务详情
            handleClick(index, row) {
                this.stopRefresh()
                this.$emit("changePage", "infoPage", row.id)
            },
            // 复制任务
            toCopyConfigPage(index, row) {
                console.log('toCopyConfigPage',index,row);
                this.stopRefresh();
                this.$emit("changePage", "configPage",row.id);
            },
            // 重试任务
            retryTask(row){
                row.retryLoading = true;
                API.retryTask({
                    task_id: row.id
                }).then(res=>{
                    row.retryLoading = false;
                    this.$message.success(res.info||'操作成功');
                    this.polling({...this.queryParams});
                },err=>{
                    row.retryLoading = false;
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info||'操作异常');
                })

            },
            toConfigPage() {
                this.stopRefresh();
                this.$emit("changePage", "configPage")
            },
            // 每页条数
            handleSizeChange(val) {
                this.pageSize = val
                this.inin()
            },
            // 当前页数
            handleCurrentChange(val) {
                this.currentPage = val
                this.inin()
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                    return 'gray-row';
                }
                return '';
            },
            remoteAppSearchList(query){
                if (query !== '') {
                    this.appOptionsLoading = true;
                    API.getAppSearchList({
                        query:query,
                    }).then(res=>{
                        this.appOptionsLoading = false;
                        this.app = (res.data||[]).map(item=>{
                            return {
                                id:item.app_id,
                                name:item.app_name+'('+item.app_id+')',
                            }
                        });

                        this.app.forEach(item=>{
                            if(!this.allappOptions.find(inner=>inner.id==item.id&&inner.name==item.name)){
                                this.allappOptions.push({...item});
                            }
                        })
                    },err=>{
                        this.appOptionsLoading = false;
                        console.log('remoteAppSearchList err',err);
                        this.app = [];
                        if (err.code == '403') {
                            if(this.confirmTip) return;
                            this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                                this.confirmTip = null;
                            }).catch(() => {
                                this.confirmTip = null;
                            });
                            return
                        }
                    })
                } else {
                    this.app = [];
                }
            },
            remoteAccountSearchList(query){
                if (query !== '') {
                    this.accountOptionsLoading = true;
                    API.getAccountSearchList({
                        query:query,
                    }).then(res=>{
                        this.accountOptionsLoading = false;
                        this.account = (res.data||[]).map(item=>{
                            return {
                                id:item.id,
                                name:item.name+'('+item.id+')',
                            }
                        });

                        this.account.forEach(item=>{
                            if(!this.allaccountOptions.find(inner=>inner.id==item.id&&inner.name==item.name)){
                                this.allaccountOptions.push({...item});
                            }
                        })

                    },err=>{
                        this.accountOptionsLoading = false;
                        console.log('remoteAccountSearchList err',err);
                        this.account = [];
                        if (err.code == '403') {
                            if(this.confirmTip) return;
                            this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                                this.confirmTip = null;
                            }).catch(() => {
                                this.confirmTip = null;
                            });
                            return
                        }
                    })
                } else {
                    this.account = [];
                }
            },
            visibleVirtual(val,type) {
                console.log('visibleVirtual',val,type);
                if(val){
                    if(type=='account'){
                        this.$refs.virtualList.reset();
                    }
                    let value = this.formInline[type+'_id']||[];
                    let allOptions = this['all'+type+'Options'];
                    this[type] = value.map(item=>{
                        let actionItem = allOptions.find(inner=>inner.id==item);
                        return {
                            name:actionItem?actionItem.name:item,
                            id:item,
                        }
                    })
                }
            },
            getDepartmentSearchList(){
                this.departmentOptionsLoading = true;
                API.getDepartmentSearchList({
                    query:'',
                }).then(res=>{
                    this.departmentOptionsLoading = false;
                    let resData = res.data||[];
                    this.department = (resData||[]).map(item=>{
                        return {
                            id:item.id,
                            name:item.name,
                        }
                    });
                },err=>{
                    this.departmentOptionsLoading = false;
                    this.department = [];
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                })
            },
            getCreatorSearchList(){
                this.creatorOptionsLoading = true;
                API.getCreatorSearchList({
                    query:'',
                }).then(res=>{
                    this.creatorOptionsLoading = false;
                    let resData = res.data||[];
                    this.creator = (resData||[]).map(item=>{
                        return {
                            id:item.id,
                            name:item.name,
                        }
                    });
                },err=>{
                    this.creatorOptionsLoading = false;
                    this.creator = [];
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                })
            },
            jumpToPage(){
                /* 从消息中心/或其他页面 带着参数跳转来的 */

                let $routeParams = this.$route.params;
                let $routeQuery = this.$route.query;
                let pageType = $routeParams.pageType||$routeQuery.pageType||'';
                console.log('jumpToPage',pageType,$routeParams,$routeQuery)

                if(pageType!='mi_batch_task_list') return;

                this.show = true;
                this.resetForm('formInline',false);
                this.formInline.task_id = $routeParams.search||$routeQuery.search;
                this.formInline.creator = '';
                this.inin();
            },
        },
        beforeDestroy() {
            this.stopRefresh();
        },

    }
</script>

<style lang="scss" scoped>
.list-page ::v-deep.el-table .gray-row{
    background-color: #f4f4f4;
}
.demo-form-inline{
    padding: 10px;
    margin-bottom: 10px;
}
    .mt0{
        margin-top: 0;
    }
    .bg-wrap-color{
        background-color:#F1F4F9;
    }
    .bg-color{
        background-color:#FFF;
    }

</style>
